import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loading.gif'

const _withId = /*#__PURE__*/_withScopeId("data-v-4400eafa")

_pushScopeId("data-v-4400eafa")
const _hoisted_1 = {
  src: _imports_0,
  alt: "loading"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("img", _hoisted_1))
})